module.exports = __webpack_public_path__ + "static/media/5.181d023a.png";